import {PipeType} from '../../enums/pipe-type.enum';

export const PHONE_PIPE = {
  pipe: [PipeType.Custom],
  pipeArguments: {
    0: (v: string) => `<a href="tel:${v}" class="link">${v}</a>`
  }
};
